import React, { useState } from 'react';

interface AccordionProps {
  title: string;
  children: React.ReactNode;
  defaultOpen?: boolean;
  className?: string;
  headerContent?: React.ReactNode;
}

const Accordion: React.FC<AccordionProps> = ({ 
  title, 
  children, 
  defaultOpen = false,
  className = '',
  headerContent
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className={`border border-gray-200 rounded-lg ${className}`}>
      <div className="border-b border-gray-200 bg-gray-50 rounded-t-lg">
        <div className="w-full flex items-center justify-between px-6 py-4">
          <div className="flex items-center space-x-4 flex-1">
            <h3 className="text-lg font-medium text-gray-900">{title}</h3>
            {headerContent && (
              <div className="flex-1" onClick={(e) => e.stopPropagation()}>
                {headerContent}
              </div>
            )}
          </div>
          <button
            className="flex items-center justify-center hover:bg-gray-100 p-1 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
            onClick={() => setIsOpen(!isOpen)}
            type="button"
          >
            <svg
              className={`w-5 h-5 text-gray-500 transition-transform duration-200 ${
                isOpen ? 'rotate-180' : ''
              }`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </button>
        </div>
      </div>
      
      <div className={`transition-all duration-200 ${
        isOpen ? 'max-h-none opacity-100 overflow-visible' : 'max-h-0 opacity-0 overflow-hidden'
      }`}>
        <div className="p-0">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Accordion;
